import {action} from "mobx"
import ReviewFormStoreBase from "~/stores/forms/reviews/review_form_store_base"

export default class ShopReviewFormStore extends ReviewFormStoreBase {
  init() {
    this.fetchReviewInit()
  }

  getInitApiUrl() {
    return "/api/reviews/shops/init"
  }

  getPostApiUrl() {
    return "/api/reviews/shops"
  }

  @action.bound
  handlePostSuccess() {
    this.rating = 0
    this.content = ''
  }
}
